
import { Injectable } from '@angular/core';
import { CotacaoRamoService } from './cotacao-ramo.service';
import { UtilsService } from '../utils.service';
import { IntegracaoConstants } from 'src/app/constants/integracao';
import { CalcsResults } from 'src/app/models/calculos/calcs-results.model';
import { CalcVidaGlobal } from 'src/app/models/calcVidaGlobal.model';

@Injectable({
  providedIn: 'root'
})

export class CotacaoVidaGlobalService implements CotacaoRamoService {

  public _seguradorasBase = IntegracaoConstants.seguradoras
  private _stepsId = IntegracaoConstants.stepsId;
  private _ramos = IntegracaoConstants.ramos;
  private tipoReq = 5;
  private _packageType = IntegracaoConstants.packageType;

  constructor(
    private utilsService: UtilsService
  ) { }

  sessoesPDF() {
    return [{
      code: 1,
      description: "Segurado",
      selected: true
    },
    {
      code: 3,
      description: "Coberturas",
      selected: true
    },
    {
      code: 4,
      description: "Cálculos com erro",
      selected: true
    }]
  }

  setComissaoDefault(su) {
    su.percComissao = su.percComissaoVidaGlobal ? su.percComissaoVidaGlobal : 0;
    su.percDesconto = su.percDescontoVidaGlobal ? su.percDescontoVidaGlobal : 0;
    su.percAgenciamento = su.percAgenciamentoVidaGlobal ? su.percAgenciamentoVidaGlobal : 0;
    return su;
  }

  setCoberturas(v, obj) {
    return null;
  }

  getMessageCalcExtension(subramo?) {
    return 'VER_CALCULO_VIDA_GLOBAL';
  }

  getColumnsGridCalculosVersao() {
    return [
      'seguradora',
      'premio',
      'comissao',
      'morte',
      'morteAcidental',
      'invalidezPermanente',
      'isInvalidezDoenca',
      'funeral',
      'tempo'
    ];
  }

  getCalcObject(draft, seguradoras, coberturas) {
    let obj = JSON.parse(JSON.stringify(draft));

    obj.ramo = this._ramos.VIDA_GLOBAL;
    obj.tipo = 5;

    let hoje = new Date();

    let vigIni = new Date(obj.vigenciaIni);
    let limiteRetroativo: any = new Date();
    limiteRetroativo = this.utilsService.editarData({ data: limiteRetroativo, operacao: "-", dia: 15, mes: 0, ano: 0 });

    if (limiteRetroativo)
      if (limiteRetroativo.getTime() > vigIni.getTime()) {
        obj.vigenciaIni = hoje.toISOString();
      }

    for (let prop in obj) {
      if (obj === null)
        delete obj[prop];
    }

    obj.calculos = seguradoras.habilitadas.filter(function (cfg) { return cfg.ativo });

    obj.calculos = obj.calculos.map(function (el) {
      let objCalc = { ...el, ...this.coberturasCalc };
      objCalc.percComissao = el.percCom ? parseInt(el.percCom) : 0;
      objCalc.percDesconto = el.percDesc ? Math.abs(parseInt(el.percDesc)) : 0;

      this.utilsService.clearCfgSegToCalc(objCalc);

      if (!objCalc.libertyCodigoEstabelacimento)
        objCalc.libertyCodigoEstabelacimento = 1;
      if (!objCalc.libertyDescontoRegional)
        objCalc.libertyDescontoRegional = 1;
      delete objCalc.ID;
      delete objCalc.percAgenciamentoVida

      return objCalc;

    }.bind(this));

    return obj;

  }

  coberturasMerge(coberturas, obj) {
    return coberturas;
  }

  getSeguradorasStatus(seguradorasUser, servicesInfos, ramo) {
    let segStatus = JSON.parse(JSON.stringify(servicesInfos.calculos.vida.global));

    for (let idx in segStatus) {

      let options = segStatus[idx];

      let reduced = options.reduce((filtered, option) => {
        let seg = seguradorasUser.find((cfgUser) => { return option.id == cfgUser.seguradora });

        if (seg && seg.seguradora != this._seguradorasBase.AZUL.id && seg.seguradora != this._seguradorasBase.ALIRO.id) {

          seg.idIntegracaoCfg = seg.ID;
          seg.idIntegracaoCfgSeg = seg.ID;

          seg.login = seg.usuario;

          seg.percCom = seg.percComissao;
          seg.percDesc = Math.abs(seg.percDesconto);

          let cfgSegConfig = { ...option, ...seg };

          filtered.push(cfgSegConfig);

        }

        return filtered;

      }, []);

      segStatus[idx] = reduced;
      segStatus[idx].sort(function (a, b) {
        if (a.nome > b.nome) {
          return 1;
        }
        if (a.nome < b.nome) {
          return -1;
        }
        return 0;
      });

    }

    return segStatus;
  }

  async getCoberturasUser(api) {
    return null;
  }

  matStepRoute(action, selectedStep, flags) {
    switch (selectedStep) {
      case this._stepsId.formulario:
        if (action == "next") {
          return "enviarCalculo";
        } else if (action == "previous") {
          return "resultados";
        }
        break;
      case this._stepsId.simuladorComissoes:
        if (action == "next") {
          return "simuladorComissoes";
        } else if (action == "previous") {
          return "resultados";
        }
        break;
      case this._stepsId.enviarCalculo:
        if (action == "next") {
          return "calcular";
        } else if (action == "previous") {
          if (flags.simuladorComissoes) {
            return "simuladorComissoes";
          } else if (flags.calcular) {
            return "resultados";
          } else {
            return "formulario"
          }
        }
        break;
    }
  }

  createDraft(negocio, opt?) {
    if (!negocio)
      negocio = new CalcVidaGlobal();
    negocio.tipo = this.tipoReq;
    if (opt) {
      if (opt.seguradoUrl) {
        let propertiesToCopy = [
          "nome",
          "cpfCnpj",
          "fone1",
          "fone",
          "cep",
          "email"
        ];
        propertiesToCopy.forEach((p) => {
          negocio.segurado[p] = opt.seguradoUrl[p];
        });
        negocio.segurado.seguradoUrl = true;
      }
      if (opt.negocioUrl) {
        negocio.negocioId = opt.negocioUrl;
      }
    }
    return negocio;
  }

  createVersions(arrayVersions) {
    return arrayVersions.map((v) => {

      //Se não tiver versão, é calculo antigo, e respectivamente é a primeira versão, ou
      //Versão é igual a 0 e foi somente salvo, sem calcular, não deveria acessar a tela de resultado, somente o formulario.
      if (!v.versao && v.versao !== 0)
        v.versao = 1;

      this.addVersion(v);

      this.utilsService.setResultsAll(v);
      this.utilsService.sortResults(v);

      return v;

    });
  }

  private addVersion(v) {

    v.vigenciaIniTxt = this.utilsService.dateStringToTxt(v.vigenciaIni);

    v.segurado.cpfCnpjTxt = this.utilsService.cpfCnpj(v.segurado.cpfCnpj);

    v.segurado.cepTxt = this.utilsService.formatCep(v.segurado.cep);

    v.configuracoes.capitalSocioTxtRS = this.utilsService.numberFormat(v.configuracoes.capitalSocio, true);

    v.configuracoes.capitalFuncionarioTxtRS = this.utilsService.numberFormat(v.configuracoes.capitalFuncionario, true);

    v.results = new CalcsResults();

    this.updateResults(v);

  }

  public updateResults(v) {
    v.calculos.map((vr) => {
      this.extractResultsVidaGlobal(v, vr);
    });
    this.utilsService.setResultsAll(v);
    this.utilsService.sortResults(v);
  }

  private extractResultsVidaGlobal(v, calc) {

    delete calc['corretora'];

    let id = 0;


    let iterarCalcs = calc.resultados;

    if (!Array.isArray(iterarCalcs) || iterarCalcs.length == 0) {
      let copyToResult = JSON.parse(JSON.stringify(calc));
      copyToResult.principal = true;
      iterarCalcs = [copyToResult];
    }
    v.configuracoes.capitalFuncionarioTxtRS = v.configuracoes.capitalFuncionario ? this.utilsService.numberFormat(v.configuracoes.capitalFuncionario, true) : "";
    v.configuracoes.capitalSocioTxtRS = v.configuracoes.capitalSocio ? this.utilsService.numberFormat(v.configuracoes.capitalSocio, true) : "";
    v.configuracoes.morteTxt = "Sim";
    v.configuracoes.invalidezPermanenteTxt = v.configuracoes.isAppInvalidez ? "Sim" : "Não";
    v.configuracoes.morteAcidentalTxt = v.configuracoes.isAppMorteAcidental ? "Sim" : "Não";
    v.configuracoes.isInvalidezDoencaTxt = v.configuracoes.isInvalidezDoenca ? "Sim" : "Não";
    v.configuracoes.funeralTxt = v.configuracoes.funeral?.tipo ? this.getFuneral(v.configuracoes.funeral?.tipo) : "--";

    if (iterarCalcs) {

      iterarCalcs.map(function (vrr) {
        id = id + 1;
        vrr.ramo = this.ramo;
        vrr.retorno = calc.retorno;
        vrr.idPacote = calc.seguradora + "-" + id;
        vrr.nome = this.utilsService.getSegNameById(calc.seguradora);
        vrr.logo = this.utilsService.getPathLogoById(calc.seguradora);
        vrr.tempoResposta = calc.tempoResposta ? calc.tempoResposta / 1000 : "";
        vrr.isError = calc.erros ? calc.erros.length > 0 : false;
        vrr.seguradora = calc.seguradora;

        vrr.isComissaoAdicional = vrr.comissaoAdicional ? true : false;
        if (vrr.isComissaoAdicional)
          vrr.comissaoAdicionalTxt = this.utilsService.numberFormat(vrr.comissaoAdicional);

        if (vrr.principal && !vrr.identificacao) {
          vrr.identificacao = "Principal";
        } else if (!vrr.principal && !vrr.identificacao) {
          vrr.identificacao = "Alternativo";
        }

        vrr.identificacaoLim = vrr.identificacao;

        if (vrr.identificacaoLim.length >= 24) {
          vrr.identificacaoLim = vrr.identificacaoLim.replace(/(.{0,22}).*/, "$1...")
        }

        vrr.idIntegracaoCfgSeg = calc.idIntegracaoCfgSeg;

        vrr.premioTxt = vrr.premio ? this.utilsService.numberFormat(parseFloat(vrr.premio)) : "--";
        vrr.premioTxtRS = vrr.premio ? this.utilsService.numberFormat(parseFloat(vrr.premio), true) : "--";

        if (vrr.coberturas) {
          vrr.coberturas.percDesconto = vrr.coberturas.percDesconto ? Math.abs(vrr.coberturas.percDesconto) : "--";

          vrr.coberturas.percComissaoTxt = vrr.coberturas.percComissao ? (vrr.coberturas.percComissao + "%") : "--";

          vrr.coberturas.morteTxt = vrr.coberturas.morte ? this.utilsService.numberFormat(vrr.coberturas.morte) : "--";
          vrr.coberturas.morteTxtRS = vrr.coberturas.morte ? this.utilsService.numberFormat(vrr.coberturas.morte, true) : "";

          vrr.coberturas.morteSocioTxt = vrr.coberturas.morteSocio ? this.utilsService.numberFormat(vrr.coberturas.morteSocio) : "--";
          vrr.coberturas.morteSocioTxtRS = vrr.coberturas.morteSocio ? this.utilsService.numberFormat(vrr.coberturas.morteSocio, true) : "";

          vrr.coberturas.morteAcidentalTxt = vrr.coberturas.morteAcidental ? this.utilsService.numberFormat(vrr.coberturas.morteAcidental) : "--";
          vrr.coberturas.morteAcidentalTxtRS = vrr.coberturas.morteAcidental ? this.utilsService.numberFormat(vrr.coberturas.morteAcidental, true) : "";

          vrr.coberturas.morteAcidentalSocioTxt = vrr.coberturas.morteAcidentalSocio ? this.utilsService.numberFormat(vrr.coberturas.morteAcidentalSocio) : "--";
          vrr.coberturas.morteAcidentalSocioTxtRS = vrr.coberturas.morteAcidentalSocio ? this.utilsService.numberFormat(vrr.coberturas.morteAcidentalSocio, true) : "";

          vrr.coberturas.invalidezPermanenteTxt = vrr.coberturas.invalidezPermanente ? this.utilsService.numberFormat(vrr.coberturas.invalidezPermanente) : "--";
          vrr.coberturas.invalidezPermanenteTxtRS = vrr.coberturas.invalidezPermanente ? this.utilsService.numberFormat(vrr.coberturas.invalidezPermanente, true) : "";

          vrr.coberturas.invalidezPermanenteSocioTxt = vrr.coberturas.invalidezPermanenteSocio ? this.utilsService.numberFormat(vrr.coberturas.invalidezPermanenteSocio) : "--";
          vrr.coberturas.invalidezPermanenteSocioTxtRS = vrr.coberturas.invalidezPermanenteSocio ? this.utilsService.numberFormat(vrr.coberturas.invalidezPermanenteSocio, true) : "";
        
          vrr.coberturas.isInvalidezDoencaTxt = vrr.coberturas.isInvalidezDoenca ? this.utilsService.numberFormat(vrr.coberturas.isInvalidezDoenca) : "--";
          vrr.coberturas.isInvalidezDoencaTxtRS = vrr.coberturas.isInvalidezDoenca ? this.utilsService.numberFormat(vrr.coberturas.isInvalidezDoenca, true) : "";

          vrr.coberturas.isInvalidezDoencaSocioTxt = vrr.coberturas.isInvalidezDoencaSocio ? this.utilsService.numberFormat(vrr.coberturas.isInvalidezDoencaSocio) : "--";
          vrr.coberturas.isInvalidezDoencaSocioTxtRS = vrr.coberturas.isInvalidezDoencaSocio ? this.utilsService.numberFormat(vrr.coberturas.isInvalidezDoencaSocio, true) : "";

          vrr.coberturas.funeralTxt = typeof vrr.coberturas.funeral == "boolean" ? (vrr.coberturas.funeral ? "Sim" : "Não") : "--";

          if (typeof vrr.coberturas.funeral == "boolean")
            vrr.coberturas.funeralTxt = vrr.coberturas.funeral ? "Sim" : "Não";
          else if (typeof vrr.coberturas.funeral == "number")
            vrr.coberturas.funeralTxt = vrr.coberturas.funeral > 0 ? "Sim" : "Não";
          else
            vrr.coberturas.funeralTxt = "--";

          if (typeof vrr.coberturas.funeral == "boolean")
            vrr.coberturas.funeralTxtCob = vrr.coberturas.funeral ? "Sim" : "Não";
          else if (typeof vrr.coberturas.funeral == "number")
            vrr.coberturas.funeralTxtCob = this.utilsService.numberFormat(vrr.coberturas.funeral, true);
          else
            vrr.coberturas.funeralTxtCob = "";

          vrr.coberturas.funeralSocioTxt = typeof vrr.coberturas.funeralSocio == "boolean" ? (vrr.coberturas.funeralSocio ? "Sim" : "Não") : "--";

          if (typeof vrr.coberturas.funeralSocio == "boolean")
            vrr.coberturas.funeralSocioTxt = vrr.coberturas.funeralSocio ? "Sim" : "Não";
          else if (typeof vrr.coberturas.funeralSocio == "number")
            vrr.coberturas.funeralSocioTxt = vrr.coberturas.funeralSocio > 0 ? "Sim" : "Não";
          else
            vrr.coberturas.funeralSocioTxt = "--";

          if (typeof vrr.coberturas.funeralSocio == "boolean")
            vrr.coberturas.funeralSocioTxtCob = vrr.coberturas.funeralSocio ? "Sim" : "Não";
          else if (typeof vrr.coberturas.funeralSocio == "number")
            vrr.coberturas.funeralSocioTxtCob = this.utilsService.numberFormat(vrr.coberturas.funeralSocio, true);
          else
            vrr.coberturas.funeralSocioTxtCob = "";

        } else {
          vrr.coberturas = {};
        }

        vrr.msErros = calc.erros;

        vrr.msAlertas = vrr.alertas ? vrr.alertas.concat( calc.alertas ) : calc.alertas;

        let verificarPremio = vrr.premio && vrr.premio > 0;

        if (vrr.retorno && !vrr.isError && !verificarPremio) {
          vrr.isError = true;
          vrr.msErros = ["Houve um erro não identificado ao realizar este cálculo."];
        }

        let arrToAdd = vrr.isError ? "errors" : "successes";
        if (vrr.hasOwnProperty('packageType') && Object.values(this._packageType).includes(vrr.packageType)) {
          if (vrr.packageType === this._packageType.PRINCIPAL) {
            vrr.isAlternative = !vrr?.selected;
            v.results[vrr?.selected ? 'main' : 'alternatives'][arrToAdd].push(vrr);
          } else if (vrr.packageType === this._packageType.MENSAL) {
            vrr.isPorAssinatura = true;
            v.results.porAssinatura[arrToAdd].push(vrr);
          } else {
            vrr.isAlternative = true;
            v.results.alternatives[arrToAdd].push(vrr);
          }
        } else {
          let isAlternative = this.utilsService.isCalcAutoAlternative(calc.seguradora);

          if( !vrr.coberturas.hasOwnProperty("percDesconto") || vrr.coberturas.percDesconto == null || vrr.coberturas.percDesconto == "--" )
            vrr.coberturas.percDescontoTxt = "0";
          else
            vrr.coberturas.percDescontoTxt = Math.abs(vrr.coberturas.percDesconto) + " %";
  
          if (vrr.principal && !isAlternative) {
            vrr.isAlternative = false;
            v.results.main[arrToAdd].push(vrr);
          } else if ((!vrr.isError) || isAlternative) {
            vrr.isAlternative = true;
            v.results.alternatives[arrToAdd].push(vrr);
          }
        }
      }.bind(this));

    }
  }

  getFuneral(v) {
    let funeral = IntegracaoConstants.assistFuneralViewValue
    let funCob =  funeral.find(f => {
      return f.value === v
    });

    return funCob.viewValue
  }
}
